import { useEffect } from 'react';
import { Footer, useToastNotifications } from '@nbirl/nbi-common-ui-libs';

export type ActionsBarProps = {
  children?: React.ReactNode;
};

export const ActionsBar = ({ children }: ActionsBarProps) => {
  const { setHasBottomMargin } = useToastNotifications();

  useEffect(() => {
    setHasBottomMargin(true);

    return () => {
      setHasBottomMargin(false);
    };
  });

  return (
    <Footer
      className="fixed bottom-0 left-0 w-full h-18 space-x-5"
      justify="end"
    >
      {children}
    </Footer>
  );
};
